import type { GroupviewPanelState } from 'dockview';
import type { PanelConfig } from '../../../../types/LayoutConfig';

/**
 * Reads a panel's strongly-typed {@link PanelConfig} from its dockview entry. Dockview types `params` as
 * `{ [key: string]: any }`, so this is the single boundary where we reconcile that with our discriminated
 * union. Prefer this helper over re-casting `panel.params` elsewhere.
 */
export function getPanelConfig(panel: GroupviewPanelState | undefined): PanelConfig | undefined {
  return panel?.params as PanelConfig | undefined;
}
